import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAppContext } from 'services/context';

import AudioPlayer from 'components/AudioPlayer';
import Button from 'components/Button';
import Container from 'components/Container';
import VideoPlayer from 'components/VideoPlayer';
import { useTranslation } from 'services/hooks';

import './style.css';

export const MediaPlayerPage = () => {
	const { video, courses } = useAppContext();
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();

	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'media_player';

	const videoSrc = searchParams.get('video_src');
	const audioSrc = searchParams.get('audio_src');

	const _handlePressbackButton = () => {
		try {
			navigate(-1);
		} catch (err) {}
	};

	if (audioSrc) return <AudioPlayer src={audioSrc} courseId={-1} />;
	if (videoSrc) return <VideoPlayer src={videoSrc} courseId={-1} />;

	return (
		<Container className="MediaPlayerPage">
			{(video?.isAudio || video?.isVideo) && (
				<Button
					small
					title={getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_back_button`)}
					startIcon="clipboardIcon"
					onClick={_handlePressbackButton}
					extraClassName="transparent"
				/>
			)}
			{video?.isVideo && <VideoPlayer src={video?.src} title={video?.title || ''} courseId={courses?.currentCourse?.courseId || -1} />}
			{video?.isAudio && (
				<>
					<div className="MediaPlayerPage__title">{video?.title || ''}</div>
					<AudioPlayer
						src={video?.src}
						// src={'https://ringtonedownload.net/wp-admin/audio-user/cut-audio-user/birds-ringtones013-koyal-cut.mp3'}
					/>
				</>
			)}
		</Container>
	);
};
